export const VERSION = {
  "release-version":"@release-version@"
};